webpackJsonp([35783957827783],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CasestudyNodeFragment = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:hover .card {\n    position: relative;\n    top: -1px;\n  }\n'], ['\n  &:hover .card {\n    position: relative;\n    top: -1px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &.ui.menu {\n    margin-top: .3em;\n    margin-bottom: 2em;\n    .container {\n      justify-content: center;\n    }\n    .item {\n      opacity: 0.3;\n      &:hover, &:active {\n        opacity: 1;\n      }\n      &:active {\n        color: ', ';\n      }\n    }\n  }\n'], ['\n  &.ui.menu {\n    margin-top: .3em;\n    margin-bottom: 2em;\n    .container {\n      justify-content: center;\n    }\n    .item {\n      opacity: 0.3;\n      &:hover, &:active {\n        opacity: 1;\n      }\n      &:active {\n        color: ', ';\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(94);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _tags = __webpack_require__(109);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	var PortfolioMenu = (0, _styledComponents2.default)(_semanticUiReact.Menu)(_templateObject2, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var PortfolioCard = function PortfolioCard(_ref) {
	  var casestudy = _ref.casestudy,
	      expand = _ref.expand;
	  var heroImage = casestudy.heroImage,
	      title = casestudy.title,
	      slug = casestudy.slug,
	      abstract = casestudy.abstract,
	      publishDate = casestudy.publishDate,
	      tags = casestudy.tags;
	
	
	  var formatDate = function formatDate(date) {
	    var objDate = new Date(date);
	    return objDate.toLocaleString('en', { month: 'short' }) + ' ' + objDate.toLocaleString('en', { year: 'numeric' });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      CardLink,
	      { to: '/portfolio/' + slug + '/' },
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { raised: true, fluid: true },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: heroImage.sizes, backgroundColor: '#EEE' }),
	        expand && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            formatDate(publishDate)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Description,
	            null,
	            abstract.abstract.substr(0, 50)
	          )
	        )
	      )
	    ),
	    expand && _react2.default.createElement(_tags2.default, { items: tags })
	  );
	};
	
	var PortfolioGrid = function (_React$Component) {
	  _inherits(PortfolioGrid, _React$Component);
	
	  function PortfolioGrid() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PortfolioGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fullView: true
	    }, _this.handleViewToggle = function () {
	      return _this.setState({ fullView: !_this.state.fullView });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PortfolioGrid.prototype.componentWillMount = function componentWillMount() {
	    var fullView = this.props.fullView;
	
	    if (typeof fullView != 'undefined') {
	      this.setState({ fullView: fullView });
	    }
	  };
	
	  PortfolioGrid.prototype.render = function render() {
	    var fullView = this.state.fullView;
	    var casestudies = this.props.casestudies;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        PortfolioMenu,
	        { secondary: true, icon: true, size: 'huge' },
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              { name: 'Show/Hide Info', onClick: this.handleViewToggle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'block layout' }),
	              '\xA0\xA0',
	              fullView ? 'Hide' : 'View',
	              ' info'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { stackable: true, columns: 3 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          casestudies.map(function (_ref2) {
	            var casestudy = _ref2.node;
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: casestudy.id },
	              _react2.default.createElement(PortfolioCard, { casestudy: casestudy, expand: fullView })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return PortfolioGrid;
	}(_react2.default.Component);
	
	var CasestudyNodeFragment = exports.CasestudyNodeFragment = '** extracted graphql fragment **';
	
	exports.default = PortfolioGrid;

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PostNodeFragment = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    li {\n      margin-bottom: 4.5em;\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  '], ['\n    li {\n      margin-bottom: 4.5em;\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    color: ', ';\n    font-size: 1.433em; \n  '], ['\n    color: ', ';\n    font-size: 1.433em; \n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  '], ['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ', ';\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  '], ['\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ', ';\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.ul(_templateObject);
	
	var PostHeaderLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, function (props) {
	  return props.theme.colors.base;
	});
	
	var ButtonLink = (0, _styledComponents2.default)(_semanticUiReact.Button)(_templateObject3);
	var PostLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject4, function (props) {
	  return props.theme.colors.base;
	});
	
	var PostList = function PostList(_ref) {
	  var posts = _ref.posts;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    posts.map(function (_ref2) {
	      var post = _ref2.node,
	          index = _ref2.index;
	      return _react2.default.createElement(
	        'li',
	        { key: post.id },
	        _react2.default.createElement(
	          _semanticUiReact.Header,
	          { as: 'h3' },
	          _react2.default.createElement(
	            PostHeaderLink,
	            { to: '/blog/' + post.slug + '/' },
	            post.title
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          post.abstract.abstract.substr(0, 50),
	          ' ...'
	        ),
	        _react2.default.createElement(
	          ButtonLink,
	          null,
	          _react2.default.createElement(
	            PostLink,
	            { to: '/blog/' + post.slug + '/' },
	            'Read More'
	          )
	        )
	      );
	    })
	  );
	};
	
	var PostNodeFragment = exports.PostNodeFragment = '** extracted graphql fragment **';
	
	exports.default = PostList;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  & {\n    ', '\n  }\n  a {\n    ', '\n    &:last-child { margin-right: 0; }\n    \n    color: inherit;\n    &:hover {\n      color: ', ';\n    }\n  }\n'], ['\n  & {\n    ', '\n  }\n  a {\n    ', '\n    &:last-child { margin-right: 0; }\n    \n    color: inherit;\n    &:hover {\n      color: ', ';\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.textAlign && 'text-align: ' + props.textAlign + ';';
	}, function (props) {
	  return props.relaxed && 'margin-right: 1em;';
	}, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var SocialIconLinks = function SocialIconLinks(_ref) {
	  var size = _ref.size,
	      rest = _objectWithoutProperties(_ref, ['size']);
	
	  return _react2.default.createElement(
	    Wrapper,
	    rest,
	    _react2.default.createElement(
	      'a',
	      { href: '//github.com/' + _siteConfig2.default.githubHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'github' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '//twitter.com/' + _siteConfig2.default.twitterHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'twitter' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '//linkedin.com/in/' + _siteConfig2.default.linkedinHandle, target: '_blank' },
	      _react2.default.createElement(_semanticUiReact.Icon, { size: size, name: 'linkedin' })
	    )
	  );
	};
	
	SocialIconLinks.propTypes = {
	  size: _propTypes2.default.string,
	  relaxed: _propTypes2.default.bool
	};
	
	SocialIconLinks.defaultProps = {
	  size: 'large',
	  relaxed: false
	};
	
	exports.default = SocialIconLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  height: 100%;\n'], ['\n  flex: 1;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &.ui.header {\n    font-size: 1.6em;\n  }\n'], ['\n  &.ui.header {\n    font-size: 1.6em;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 1.25em;\n'], ['\n  font-size: 1.25em;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    &.ui.header {\n      font-size: 2.6em;\n      margin-bottom: 0.1em;\n      margin-top: .25em;\n    }\n  '], ['\n    &.ui.header {\n      font-size: 2.6em;\n      margin-bottom: 0.1em;\n      margin-top: .25em;\n    }\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    font-size: 1.26em;\n    opacity: .46;\n  '], ['\n    font-size: 1.26em;\n    opacity: .46;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  '], ['\n    &.ui.button {\n      padding: 0;\n      a {\n        padding: 0.5em 1.2em;\n      }\n    }\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: block;\n  color: inherit;\n  margin-bottom: 3px;\n  &:hover {\n    color: inherit;\n  }\n'], ['\n  display: block;\n  color: inherit;\n  margin-bottom: 3px;\n  &:hover {\n    color: inherit;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-size: 1.15rem;\n'], ['\n  font-size: 1.15rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin-top: 2em;\n'], ['\n  text-align: center;\n  margin-top: 2em;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 2em;\n'], ['\n  margin-bottom: 2em;\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  letter-spacing: 1px;\n'], ['\n  letter-spacing: 1px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _reactSemanticBooster = __webpack_require__(38);
	
	var _PortfolioGrid = __webpack_require__(165);
	
	var _PortfolioGrid2 = _interopRequireDefault(_PortfolioGrid);
	
	var _PostList = __webpack_require__(166);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	var _SocialIconLinks = __webpack_require__(169);
	
	var _SocialIconLinks2 = _interopRequireDefault(_SocialIconLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var SectionHeader = (0, _styledComponents2.default)(_semanticUiReact.Header)(_templateObject2);
	
	var SectionLead = _styledComponents2.default.p(_templateObject3);
	
	var Title = (0, _styledComponents2.default)(_semanticUiReact.Header)(_templateObject4);
	
	var Subtitle = _styledComponents2.default.p(_templateObject5);
	
	var ButtonLink = (0, _styledComponents2.default)(_semanticUiReact.Button)(_templateObject6);
	
	var PaddedLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject7);
	
	var LargeContainer = (0, _styledComponents2.default)(_semanticUiReact.Container)(_templateObject8);
	
	var ViewMoreContainer = _styledComponents2.default.div(_templateObject9);
	
	var HeroContainer = _styledComponents2.default.div(_templateObject10);
	
	var CaptionTitle = (0, _styledComponents2.default)(_semanticUiReact.Header)(_templateObject11);
	
	var Index = function Index(_ref) {
	  var data = _ref.data;
	
	  var posts = data.allContentfulPost.edges;
	  var casestudies = data.allContentfulCasestudy.edges;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { spacer: 2, textAlign: 'center' },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { text: true },
	        _react2.default.createElement(
	          HeroContainer,
	          null,
	          _react2.default.createElement(
	            CaptionTitle,
	            { sub: true, as: 'h1' },
	            _siteConfig2.default.siteTitle
	          ),
	          _react2.default.createElement(
	            Title,
	            { as: 'h2' },
	            _siteConfig2.default.siteBio
	          ),
	          _react2.default.createElement(
	            Subtitle,
	            null,
	            _siteConfig2.default.siteBioDesc
	          )
	        ),
	        _react2.default.createElement(_SocialIconLinks2.default, { relaxed: true })
	      )
	    ),
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { textAlign: 'center' },
	      _react2.default.createElement(
	        LargeContainer,
	        null,
	        _react2.default.createElement(
	          SectionHeader,
	          { as: 'h2' },
	          'My Work'
	        ),
	        casestudies && _react2.default.createElement(_PortfolioGrid2.default, { fullView: false, casestudies: casestudies }),
	        _react2.default.createElement(
	          ViewMoreContainer,
	          null,
	          _react2.default.createElement(
	            ButtonLink,
	            { basic: true, circular: true },
	            _react2.default.createElement(
	              PaddedLink,
	              { to: '/portfolio' },
	              'View more'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { attached: true },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { text: true },
	        posts && _react2.default.createElement(_PostList2.default, { posts: posts }),
	        _react2.default.createElement(
	          ViewMoreContainer,
	          null,
	          _react2.default.createElement(
	            ButtonLink,
	            { basic: true, circular: true },
	            _react2.default.createElement(
	              PaddedLink,
	              { to: '/blog' },
	              'View more'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Container,
	      { text: true },
	      _react2.default.createElement(_semanticUiReact.Divider, null)
	    ),
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { textAlign: 'center', spacer: 1.5 },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { text: true },
	        _react2.default.createElement(
	          SectionHeader,
	          { as: 'h2' },
	          'I\'d love to hear from you'
	        ),
	        _react2.default.createElement(
	          SectionLead,
	          null,
	          'Got a project to share? Feel free to get in touch.'
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        _react2.default.createElement(
	          ButtonLink,
	          { primary: true, size: 'huge', circular: true },
	          _react2.default.createElement(
	            PaddedLink,
	            { to: '/contact' },
	            'Message me'
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ff5dac5ddb4396d47411.js